;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/control/customers/:organizationId\",\"regex\":\"^/control/customers/([^/]+)$\",\"paramNames\":[\"organizationId\"],\"hasOptionalPrefix\":false},{\"path\":\"/control/integrations/:provider\",\"regex\":\"^/control/integrations/([^/]+)$\",\"paramNames\":[\"provider\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/access-denied\"},{\"path\":\"/control\"},{\"path\":\"/control/ai\"},{\"path\":\"/control/audit\"},{\"path\":\"/control/billing\"},{\"path\":\"/control/communications\"},{\"path\":\"/control/configuration\"},{\"path\":\"/control/customers\"},{\"path\":\"/control/integrations\"},{\"path\":\"/control/jobs\"},{\"path\":\"/control/operators\"},{\"path\":\"/control/revenue\"},{\"path\":\"/control/system-health\"},{\"path\":\"/control/users\"},{\"path\":\"/sign-in\"},{\"path\":\"/two-factor\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.2";import * as Sentry from "@sentry/nextjs";

function sampleRate(raw: string | undefined, fallback: number) {
  if (!raw?.trim()) return fallback;
  const value = Number(raw);
  return Number.isFinite(value) && value >= 0 && value <= 1 ? value : fallback;
}

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN?.trim();
if (dsn) {
  Sentry.init({
    dsn,
    environment: window.location.hostname.startsWith("staging.") ? "staging" : "production",
    release: process.env.NEXT_PUBLIC_OPTRIXIS_RELEASE?.trim() || undefined,
    tracesSampleRate: sampleRate(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE, 0.02),
    sendDefaultPii: false,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
